import { MenuItem, Select, SelectProps } from "@material-ui/core";
import Flag from "react-world-flags";

const supportedLanguages = ["it", "en"];

const flagsMap = {
  it: "it",
  en: "us",
};

export interface I18NLanguagePickerProps
  extends Omit<SelectProps, "value" | "onChange"> {
  value: string;
  onChange: (v: string) => void;
}
export function I18NLanguagePicker(props: I18NLanguagePickerProps) {
  const { value, onChange, className, ...selectProps } = props;

  return (
    <Select
      {...selectProps}
      className={`${className ?? ""} laguage-picker-select`}
      value={value}
      onChange={(evt) => onChange(evt.target.value as string)}
    >
      {supportedLanguages.map((lang) => (
        <MenuItem value={lang} key={lang}>
          <Flag height={16} code={flagsMap[lang]} />
        </MenuItem>
      ))}
    </Select>
  );
}
